var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthContainer',{on:{"onBack":_vm.handleBack}},[_c('AuthBackContainer',[_c('RegisterForm',{on:{"onBack":_vm.handleBack}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }